module.exports = __webpack_public_path__ + "static/logo3-992bbbb48d755ab953a1455bbfc4d9e1.png";